import Formats from './Formats/Formats';

const FormatTable = ({ title, format = 'old' }) => {
  return <>{Formats[`${title} ${format}`]}</>;
};

export default FormatTable;
